var htmlPaths = require("./html-paths");
var Html = require("./html");


exports.element = element;

function element(name) {
    return function(html) {
        return Html.elementWithTag(htmlPaths.element(name), [html]);
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/mammoth-style/lib/underline.js
// module id = 1981
// module chunks = 0